import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/** Grand Launch Offer state from the server (/api/settings/public → settings.offer).
 *  null while loading; { active: false } if the API is unavailable. */
export function useOffer() {
  const [offer, setOffer] = useState(null);
  useEffect(() => {
    let live = true;
    api
      .get("/settings/public")
      .then((d) => {
        if (live) setOffer((d && d.settings && d.settings.offer) || { active: false });
      })
      .catch(() => {
        if (live) setOffer({ active: false });
      });
    return () => {
      live = false;
    };
  }, []);
  return offer;
}
